import React, { useEffect, useState } from "react";
import MainComponent from "../../../../components/ui_comps/MainComponent";
import CustomStepperNew from "../../../../components/ui_comps/CustomStepperNew";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router";

import Documents from "./Documents";
import BankDetails from "./BankDetails";
import Vkyc from "./Vkyc";
import TranscationLimits from "./TranscationLimits";
import {
  addServiceData,
  addServiceSlice,
  removeServiceData,
} from "../../../../../data/redux/slice/addService";

import Service from "./Service";
import TypeService from "./TypeService";
import { removeResellerData } from "../../../../../data/redux/slice/resellerDataSlice";
import { removeClientData } from "../../../../../data/redux/slice/clientOnboardDataSlice";

const ClientAddService = ({ onClickNext, onClickPrevious, onClickCancel }) => {
  const [currentStep, setCurrentStep] = useState(1);

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const currentModalStep = useSelector(
    (state) => state.modalNavSlice.clientStep
  );

  const { state } = useLocation();
  const tabs = [
    {
      name: "Service Type",
      key: 1,
    },
    {
      name: "Service rate",
      key: 2,
    },

    {
      name: "Documents",
      key: 3,
    },
    {
      name: "Bank Details",
      key: 4,
    },
    {
      name: "VKYC",
      key: 5,
    },
    {
      name: "Transaction Limit",
      key: 6,
    },
  ];

  useEffect(() => {}, [state]);

  return (
    <div
      style={{
        width: "100%",
        // overflow: "auto",
        //boxSizing: "border-box",
        backgroundColor: "white",
        padding: "0px 30px",
        position: "relative",
      }}
    >
      <MainComponent headerTitle="Add Client" filterRequired={false} />
      <div style={styles.title}>Add Services</div>
      <div style={{ maxWidth: "60%", margin: "auto" }}>
        <CustomStepperNew
          totalStep={5}
          currentStep={currentStep}
          tabs={tabs}
          style={{ position: "relative" }}
        />
      </div>

      <div
        style={{
          width: "100%",
          //height: "100%",
          textAlign: "start",
          position: "relative",
        }}
      >
        {currentStep === 1 ? (
          <TypeService
            onClickNext={(data) => {
              setCurrentStep(2);
              dispatch(
                addServiceData({
                  ...data,
                })
              );
            }}
            onClickCancel={() => {
              navigate("/clients");
              dispatch(removeServiceData());
            }}
            clientDetails={state?.data}
          />
        ) : currentStep === 2 ? (
          <Service
            onClickNext={(data) => {
              setCurrentStep(3);
              dispatch(
                addServiceData({
                  ...data,
                })
              );
            }}
            onClickPrevious={() => {
              setCurrentStep(1);
            }}
            onClickCancel={() => {
              navigate("/clients");
              dispatch(removeServiceData());
            }}
            clientDetails={state?.data}
          />
        ) : currentStep === 3 ? (
          <Documents
            onClickNext={(data) => {
              setCurrentStep(4);
              // dispatch(
              //   addServiceData({
              //     ...data,
              //   })
              // );
            }}
            onClickPrevious={() => {
              setCurrentStep(2);
            }}
            onClickCancel={() => {
              navigate("/clients");
              dispatch(removeServiceData());
            }}
            clientDetails={state?.data}
          />
        ) : currentStep === 4 ? (
          <BankDetails
            onClickNext={(data) => {
              setCurrentStep(5);
              dispatch(
                addServiceData({
                  ...data,
                })
              );
            }}
            onClickPrevious={() => {
              setCurrentStep(3);
            }}
            onClickCancel={() => {
              navigate("/clients");
              dispatch(removeServiceData());
            }}
            clientDetails={state?.data}
            goToPage={(step) => {
              setCurrentStep(step);
            }}
          />
        ) : currentStep === 5 ? (
          <Vkyc
            onClickNext={(data) => {
              setCurrentStep(6);
              dispatch(
                addServiceData({
                  ...data,
                })
              );
            }}
            goToPage={(step) => {
              setCurrentStep(step);
            }}
            onClickPrevious={(step) => {
              setCurrentStep(step);
            }}
            onClickCancel={() => {
              navigate("/clients");
              dispatch(removeServiceData());
            }}
            clientDetails={state?.data}
          />
        ) : currentStep === 6 ? (
          <TranscationLimits
            onClickPrevious={() => {
              setCurrentStep(5);
            }}
            onClickCancel={() => {
              navigate("/clients");
              dispatch(removeServiceData());
            }}
            goToPage={(step) => {
              setCurrentStep(step);
            }}
            clientDetails={state?.data}
            onSuccess={() => {
              dispatch(removeServiceData());
              navigate("/dashboard");
            }}
          />
        ) : (
          <></>
        )}
      </div>
    </div>
  );
};

const styles = {
  title: {
    fontSize: "24px",
    fontWeight: "600",
    color: " #000000",
    textAlign: "center",
    minHeight: "70px",
    position: "relative",
    marginTop: "15px",
  },
};

export default ClientAddService;
